import { ResponseError } from "@freightsimple/generated-dashboard-openapi-client/runtime";

/** True when the API answered 404, which screens show as "not found" rather than as a failed load. */
export function isNotFoundError(error: unknown): boolean {
  return error instanceof ResponseError && error.response.status === 404;
}
